var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "filter-section" },
          [
            _c(
              "el-form",
              {
                staticClass: "filter-form",
                attrs: { inline: true, model: _vm.listPram },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "交易时间" } },
                  [
                    _c("el-date-picker", {
                      staticClass: "date-picker",
                      attrs: {
                        type: "datetimerange",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        format: "yyyy-MM-dd HH:mm:ss",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        size: "small",
                      },
                      on: { change: _vm.handleDateRangeChange },
                      model: {
                        value: _vm.dateRange,
                        callback: function ($$v) {
                          _vm.dateRange = $$v
                        },
                        expression: "dateRange",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "交易状态" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "status-select",
                        attrs: {
                          placeholder: "请选择状态",
                          size: "small",
                          clearable: "",
                        },
                        model: {
                          value: _vm.listPram.orderStatus,
                          callback: function ($$v) {
                            _vm.$set(_vm.listPram, "orderStatus", $$v)
                          },
                          expression: "listPram.orderStatus",
                        },
                      },
                      _vm._l(_vm.orderStatusOptions, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "订单编号" } },
                  [
                    _c("el-input", {
                      staticClass: "order-input",
                      attrs: {
                        placeholder: "请输入订单编号",
                        size: "small",
                        clearable: "",
                      },
                      model: {
                        value: _vm.listPram.orderNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.listPram, "orderNo", $$v)
                        },
                        expression: "listPram.orderNo",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "水表号" } },
                  [
                    _c("el-input", {
                      staticClass: "water-meter-input",
                      attrs: {
                        placeholder: "请输入水表号",
                        size: "small",
                        clearable: "",
                      },
                      model: {
                        value: _vm.listPram.waterMeterCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.listPram, "waterMeterCode", $$v)
                        },
                        expression: "listPram.waterMeterCode",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "用户手机号" } },
                  [
                    _c("el-input", {
                      staticClass: "user-phone-input",
                      attrs: {
                        placeholder: "请输入用户手机号",
                        size: "small",
                        clearable: "",
                      },
                      model: {
                        value: _vm.listPram.phone,
                        callback: function ($$v) {
                          _vm.$set(_vm.listPram, "phone", $$v)
                        },
                        expression: "listPram.phone",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "small",
                          icon: "el-icon-search",
                        },
                        on: { click: _vm.handerSearch },
                      },
                      [_vm._v("\n            搜索\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", icon: "el-icon-refresh" },
                        on: { click: _vm.resetSearch },
                      },
                      [_vm._v("\n            重置\n          ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "export-btn" },
          [
            _c(
              "el-button",
              {
                attrs: {
                  type: "primary",
                  size: "small",
                  icon: "el-icon-download",
                },
                on: { click: _vm.exportOrder },
              },
              [_vm._v("\n        导出订单\n      ")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                height: "70vh",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
                stripe: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "outTradeNo",
                  label: "交易单号",
                  "min-width": "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "productName",
                  label: "产品名称",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "appName", label: "小程序", "min-width": "100" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "waterMeterCode",
                  label: "水表号",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "totalFee",
                  label: "订单金额",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticStyle: { color: "#E6A23C" } }, [
                          _vm._v("¥" + _vm._s(scope.row.totalFee || "0.00")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "couponPrice",
                  label: "总优惠金额",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticStyle: { color: "#67C23A" } }, [
                          _vm._v("¥" + _vm._s(scope.row.couponPrice || "0.00")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "statusName",
                  label: "交易状态",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "payStartTime",
                  label: "交易发起时间",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "payEndTime",
                  label: "交易结束时间",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "userName",
                  label: "下单用户",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "100",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openOrderDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n            查看详情\n          ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            staticStyle: { "margin-top": "20px", "text-align": "right" },
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "order-detail-dialog",
          attrs: {
            title: "订单详情",
            visible: _vm.detailDialogVisible,
            width: "1000px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailDialogVisible = $event
            },
            close: _vm.handleDetailClose,
          },
        },
        [
          _vm.detailDialogVisible
            ? _c("OrderDetailComponent", {
                attrs: {
                  outTradeNo: _vm.currentOrderId,
                  orderDetail: _vm.orderDetail,
                  loading: _vm.detailLoading,
                },
                on: {
                  "loading-change": _vm.handleDetailLoadingChange,
                  "detail-loaded": _vm.handleDetailLoaded,
                  error: _vm.handleDetailError,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.detailDialogVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }